// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2zUtP","containerItemsCenter":"Skeleton_containerItemsCenter__2vxzA"};